import { HTTP } from 'api'

const basePath = '/Profile/'

export default {
  getUserInfo() {
    return HTTP.get(basePath);
    //return HTTP.get('../../mock/profile.json');
    
    //return HTTP.get('userinfo.json')
  }

  
}